export const ASSET_TYPE_NONS3 = {
	APK: 'apk',
	IMAGE: 'image',
	CSV: 'csv',
	ALL: 'all',
	KYC_DOC: 'kyc'
};

export type AssetType = 'apk' | 'image' | 'csv' | 'all' | 'kyc';

export interface useAssetUploadProps {
	value: any;
	onChange: any;
	setShowLoader: (value: boolean) => void;
	assetType: AssetType;
	multiple: boolean;
	label?: string;
}

export interface AssetUploadProps {
	onChange: any;
	value: any;
	disabled?: any;
	setShowLoader: any;
	assetType: AssetType;
	multiple?: boolean;
	downloadFile?: boolean;
	link?: string;
	displayText?: string;
	name: string;
	label?: string;
}

export const ACCEPTED_FILE_TYPES = {
	[ASSET_TYPE_NONS3.IMAGE]: 'image/*',
	[ASSET_TYPE_NONS3.KYC_DOC]: 'image/*',
	[ASSET_TYPE_NONS3.APK]: '.apk',
	[ASSET_TYPE_NONS3.CSV]: '.csv',
	[ASSET_TYPE_NONS3.ALL]: '*/*'
};
